// extracted by mini-css-extract-plugin
export default {"container":"DD-z","contactUsLink":"ED-z"};